import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { HttpService } from 'shared-modules/services/http.service';
import { AuthService } from './auth.service';
import { IApiResponse } from 'shared-modules/generic-models/generic.api.models';


export function ConfigFactoryProvider(configService: ConfigService) {
    return () => configService.loadConfig();
}

@Injectable({
    providedIn: 'root'
})
export class ConfigService {

    private _config: any;

    constructor (
        private _authService: AuthService,
    ) {

    }

    public loadConfig(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this._authService.accessToken && !this._authService.isTokenExpired) {
                this._authService.navigatedTo(true);
                resolve(true);
            } else {
                this._authService.getCurrentSession()
                    .then(session => {
                            this._authService.accessToken = session.accessToken.jwtToken;
                            if (this._authService.isTokenExpired) {
                                this._authService.signOut().then(resp => {
                                    this._authService.clearLocalStorage();
                                    this._authService.navigatedTo(false);
                                });
                            } else {
                                this._authService.idToken = session.idToken.jwtToken;
                        this._authService.refreshToken = session.refreshToken.token;
                                this._authService.user = JSON.stringify(session.idToken.payload);
                        // this.studentMe(resolve, reject);
                        }
                }, (error) => {
                        this._authService.clearLocalStorage();
                        this._authService.navigatedTo(false);
                        resolve(true);
                    });
            }
        });
    }
    
    // studentMe(resolve, reject) {
    //     const user = this._authService.user;
    //     localStorage.setItem('entityId', user.email);
    //     this._apiService
    //     .getList('student/studentMe', { studentEmailId: user.email }, false)
    //     .subscribe({
    //         next: (response: any) => {

    //             this._config = response;
    //             console.log('student me => ', response)
    //             this._fuseService.wishListCount = response && response.bookMarkCount ? response.bookMarkCount : 0;
    //             this._authService.navigatedTo(true);
    //             setTimeout(() => {
    //                 resolve(true);
    //             }, 500);

    //         },
    //         error: (err: IApiResponse<any>) => {
    //            console.log('fff ===== > ', err)
    //            this._authService.navigatedTo(false);
    //            resolve(true);
    //         }
    //     });
    // }

    get config(): any {
        return this._config;
    }

    get profile(): any {

        const { inCompleteSteps = [], completeSteps = [], requiredSteps = [] } = this._config;

        return {
            inCompleteSteps,
            completeSteps,
            requiredSteps
        };
    }

    get studentId(): any {
        // return 'f3322754-5d6a-495a-98f0-19676f80a1a3'
        return this._config && this._config.studentId ? this._config.studentId : null;
    }
}
